import React from 'react';
import SemanticHeader from '../platformui/Chapter/semantic-header';
import ServiceInfoBlock from './tab-container-block/service-info/serviceinfo-block';
import {
  Block as ContentAreaRenderer,
  BlockTypeRenderer,
} from '../platformui/Base/Render';
import ServiceInfoEndedOutagesBlock from './tab-container-block/service-info/service-info-ended-outages-block';
import ServiceInfoPlannedOutagesBlock from './tab-container-block/service-info/service-info-planned-outages-block';
import './tab-block.scss'
import '../components/tab-block/tab-block.scss';
/**
 * @typedef {Object} BlockType
 */

/**
 * @typedef {Object} TabBlockProps
 * @property {string} [Heading] - Optional heading text.
 * @property {string} [Description] - Optional description text.
 * @property {BlockType[]} Content - Array of blocks.
 */

/**
 * Renders a tab block with its content blocks, with an optional header and description.
 *
 * @param {TabBlockProps} props
 * @returns {JSX.Element}
 */

const Blocks = {
  ServiceInfoBlock,
  ServiceInfoPlannedOutagesBlock,
  ServiceInfoEndedOutagesBlock,
};

export const TabBlock = (props) => {
  const { Heading, Description, Content } = props;

  return (
    <>
      {Heading && (
        <SemanticHeader className="tab-block__heading">
          <span>{Heading}</span>
        </SemanticHeader>
      )}
      {Description && <p className="tab-block__description">{Description}</p>}
      <ContentAreaRenderer blocks={Content} currentPageProps={props}>
        <BlockTypeRenderer Blocks={Blocks} />
      </ContentAreaRenderer>
    </>
  );
};
